__turbopack_context__.v({
  "collapsed": "index-module__JDqxja__collapsed",
});
